export default
{
    floorHeight:-3,
    roofHeight:15,

    boids:{
        count:600,
        visualRange:1.7523,
        protectedRange:0.87892,
        enviromentVision:2,
        objectAvoidFactor:0.222,
        cohesionFactor:0.00206,
        matchingFactor:0.06312,
        seperationFactor:0.19269,
        minSpeed:2.379,
        maxSpeed:5.206,
        wallTransparent:false,
        turnFactor:0.201,
        
    },

    coralVariables:
    {
        size:40,
        rez:1,
        tileSize:2
    },

    rays:
    {
        count:50,
        angle:-0.5

    },

    fish:
    {
        colors:
        [
            '#ffea00',
            '#ffdd00',
            '#ffd000',
            '#ffc300',
            '#ffb700',
            '#ffaa00',
            '#ffa200',
            '#ff9500',
            '#ff8800',
            '#ff7b00',
            '#ba181b',
            '#e5383b',
            '#720026',
            '#e4b1ab',
        ]
    },


}